/**
 * When in dev mode, log error to console. Otherwise, do nothing.
 */
export const printDevError = (err: unknown) => {
  if (process.env.NODE_ENV === "development")
    // eslint-disable-next-line no-console
    return console.error(err.toString());
};
